<template>
    <pendo-router-link
        v-pendo-tooltip="{
            classes: 'side-nav-tooltip',
            content: tooltipContent,
            placement: 'right',
            arrow: true,
        }"
        pendo-analytics="home-nav-item"
        data-cy="home-nav-link"
        class="nav-option"
        :to="{ name: 'Home' }"
        :class="{ selected, expanded }"
        :aria-label="label"
        @click="$emit('toggle', $event)"
        @keyup.enter="$emit('toggle', $event)">
        <div class="nav-icon">
            <svg
                class="filled-icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
                    stroke="var(--palette-gray-90)"
                    stroke-width="1.75"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M9 22V12H15V22"
                    fill="var(--palette-gray-90)" />
                <path
                    d="M9 22V12H15V22"
                    stroke="var(--palette-gray-90)"
                    stroke-width="1.75"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
            <svg
                class="empty-icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
                    stroke="var(--palette-gray-90)"
                    stroke-width="1.75"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M9 22V12H15V22"
                    stroke="var(--palette-gray-90)"
                    stroke-width="1.75"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
        </div>
        <div
            v-show="expanded"
            class="label-text">
            {{ label }}
        </div>
    </pendo-router-link>
</template>

<script>
import PendoRouterLink from '@/vue-router/pendo-router-link.vue';
import { PendoTooltip } from '@pendo/components-vue3';

export default {
    name: 'Home',
    compatConfig: {
        INSTANCE_LISTENERS: false,
    },
    components: {
        PendoRouterLink,
    },
    directives: {
        PendoTooltip,
    },
    props: {
        selected: {
            type: Boolean,
            default: false,
        },
        expanded: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['toggle'],
    computed: {
        tooltipContent () {
            if (this.expanded) return '';

            return this.label;
        },
        label () {
            return this.$t('sideNav.Home');
        },
    },
};
</script>

<style scoped lang="less">
@import '@/side-nav/nav.style.less';
</style>
